import { withDisplayName } from '@hocs/with-display-name'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import { Link } from 'gatsby'
import queryString from 'query-string'
import React, { type ReactNode } from 'react'

import { useIsIframe } from '../../../plugins/gatsby-plugin-espace-client'

type InternalLinkLinkUIProps = {
  href: string
  onClick?: (event: React.SyntheticEvent) => void
  children?: ReactNode
}

const InternalLinkLinkUI: React.FC<InternalLinkLinkUIProps> = ({
  href,
  children,
  ...props
}) => {
  const isIframe = useIsIframe()
  const url = queryString.stringifyUrl({
    url: href,
    query: {
      iframe: true,
    },
  })
  return (
    <Link
      className="font-medium text-inherit underline"
      data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
      data-type={ENHANCED_COMPONENT_TYPE.CTA}
      to={isIframe ? url : href}
      {...props}
    >
      {children}
    </Link>
  )
}

export default withDisplayName(InternalLinkLinkUI, 'InternalLinkLinkUI')
